import qs from 'qs';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { TNameTitle } from '@interfaces/common/common';
import { IGroupOperationDTO } from '@interfaces/common/defaultDTO';
import { IItemsResponse } from '@interfaces/common/response';
import {
	ICheckIsMilestoneExists,
	ICreateMilestoneDTO,
	IDeleteMilestonesDTO,
	IEditMilestoneDTO,
	IGetPortalMilestonesDTO,
	IGetTasksToLinkDTO,
	IPortalMilestoneDTO,
} from '@interfaces/portal/dto/milestonesManagementDTO';
import { IPortalGroupedTasksToLinkDTO } from '@interfaces/portal/dto/taskManagementDTO';
import { IProjectUser } from '@interfaces/portal/projects';

const {
	portalMilestones,
	portalMilestonesAssignees,
	portalMilestonesGroupedTasksToLink,
	portalCreateMilestone,
	portalDeleteMilestones,
	portalMilestonesStatuses,
	portalMilestonesAssigneesFilter,
} = URL;

export const getPortalMilestones = ({
	page,
	pageSize,
	sortDirection,
	sortFieldName,
	searchValue,
	status,
	projectId,
	assignees,
}: IGetPortalMilestonesDTO): Promise<IItemsResponse<IPortalMilestoneDTO>> => {
	return client.get(portalMilestones, {
		params: {
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			searchValue,
			status,
			projectId,
			assignees,
		},
		paramsSerializer: params =>
			qs.stringify(
				Object.fromEntries(
					Object.entries(params).filter(([_, value]) => value !== null && value !== undefined),
				),
				{ indices: false },
			),
	});
};

export const getPortalMilestonesAssignees = (projectId: string): Promise<IProjectUser[]> => {
	return client.get(portalMilestonesAssignees, {
		params: {
			projectId,
		},
	});
};

export const getPortalMilestonesGroupedTasksToLink = ({
	milestoneId,
	projectId,
}: IGetTasksToLinkDTO): Promise<IPortalGroupedTasksToLinkDTO[]> => {
	return client.get(portalMilestonesGroupedTasksToLink, {
		params: {
			id: milestoneId,
			projectId,
		},
	});
};

export const createMilestone = (data: ICreateMilestoneDTO): Promise<IPortalMilestoneDTO> => {
	return client.post(portalCreateMilestone, data);
};

export const editMilestone = ({ milestoneId, dto }: IEditMilestoneDTO): Promise<IPortalMilestoneDTO> => {
	return client.post(`${portalMilestones}/${milestoneId}/update`, {
		...dto,
	});
};

export const getPortalMilestoneById = (id: string): Promise<IPortalMilestoneDTO> => {
	return client.get(`${portalMilestones}/${id}`);
};

export const removeMilestones = ({
	filter,
	ids,
	isAll,
}: IGroupOperationDTO<IDeleteMilestonesDTO | null>): Promise<void> => {
	return client.post(portalDeleteMilestones, {
		filter,
		ids,
		isAll,
	});
};

export const getPortalMilestonesAssigneesFilter = (projectId: string): Promise<IProjectUser[]> => {
	return client.get(portalMilestonesAssigneesFilter, {
		params: {
			projectId,
		},
	});
};

export const getPortalMilestonesStatuses = (): Promise<TNameTitle[]> => {
	return client.get(portalMilestonesStatuses);
};

export const checkIsMilestoneExists = ({ milestoneId }: ICheckIsMilestoneExists): Promise<void> => {
	return client.get(`${portalMilestones}/${milestoneId}/exist`);
};
